import { buildProps, definePropType } from '@ll-plus/utils'
import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'

import type TagGroup from './tag-group.vue'

export type TagSortBy = 'addOrder' | 'alphabetical'

export type TagGroupOverflowDisplay = 'collapse' | 'wrap'

export const tagGroupProps = buildProps({
  value: {
    type: definePropType<string[]>(Array),
    default: [],
  },
  options: {
    type: definePropType<string[]>(Array),
    default: [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isGray: {
    type: Boolean,
    default: true,
  },
  // 尺寸
  size: {
    type: String as () => SizeType,
  },
  listLoading: {
    type: Boolean,
    default: false,
  },
  virtual: {
    type: Boolean,
    default: false,
  },
  // 允许添加新标签
  allowCreate: {
    type: Boolean,
    default: false,
  },
  // 最大标签数
  maxTagCount: {
    type: Number,
    default: 0,
  },
  // 标签排序方式
  sortBy: {
    type: definePropType<TagSortBy>(String),
    default: 'addOrder',
  },
  triggerDistance: {
    type: Number,
    default: 50,
  },
  filter: {
    type: definePropType<(inputValue: string, options: string[]) => string[]>(
      Function,
    ),
    default: undefined,
  },
  placeholder: {
    type: String,
    default: '输入后回车新建',
  },
  emptyText: {
    type: String,
    default: '未找到匹配的标签',
  },
  overflowDisplay: {
    type: definePropType<TagGroupOverflowDisplay>(String),
    default: 'collapse',
  },
  collapseThreshold: {
    type: Number,
    default: 0,
  },
  addText: {
    type: String,
    default: '',
  },
  addIcon: {
    type: String,
    default: 'icon-add',
  },
} as const)

export const tagGroupEmits = {
  'update:value': (value: string[]) => !!value,
  'update:options': (value: any) => !!value,
  change: (value: string[]) => !!value,
  'scroll-bottom': () => true,
  input: (value: string) => !!value,
}

// props
export type TagGroupProps = ExtractPropTypes<typeof tagGroupProps>

// emits
export type TagGroupEmits = typeof tagGroupEmits

// instance
export type TagGroupInstance = InstanceType<typeof TagGroup>
